<template>
  <div class="businessChannelSelect">
    <rich-checkbox-group
      v-model="businessChannel"
      @input="businessChannelChange"
    >
      <div v-for="(item, index) in options" :key="index">
        <rich-checkbox :option="item" />
        <span
          class="check-required"
          v-if="index !== options.length - 1 && isChecked(item.value)"
        >*</span>
        <rich-input
          type="text"
          :ref="item.value"
          v-if="index !== options.length - 1 && isChecked(item.value)"
          v-model="businessRemark[item.value]"
          @blur="businessRemarkChange(item.value, index)"
          :placeholder="$t('Gattaran_0__uLBv' /**请输入订单量 */)"
          />
        <div
          class="error-msg"
          v-if="showErr[item.value] && isChecked(item.value)"
          v-text="errmsg"
        ></div>
      </div>
    </rich-checkbox-group>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es'
export default {
  data () {
    return {
      businessChannel: [],
      businessRemark: {
        1: '',
        2: '',
        3: '',
        4: '',
        5: '',
        6: ''
      },
      showErr: {},
      errmsg: this.gettext('选项和输入框不能为空')
    }
  },
  props: {
    options: {},
    value: {
      required: false,
      type: [String, Array, Object]
    }
  },
  created () {
    this.initValue(this.value)
  },
  watch: {
    value (nVal) {
      this.initValue(nVal)
    }
  },
  methods: {
    businessChannelChange () {
      this.change()
    },

    businessRemarkChange (key, ind) {
      let num = /[^\d.]/g.test(this.businessRemark[key])
      let checked = {}
      checked[key] = ''
      if (num) {
        this.businessRemark = cloneDeep(Object.assign({}, this.businessRemark, checked))
      }
      this.change()
    },

    initValue (val = [], second) {
      const businessChannel = []
      val.forEach(item => {
        for (let key in item) {
          businessChannel.push(key)
          this.businessRemark[key] = item[key]
        }
      })
      this.businessChannel = businessChannel
    },
    getValue () {
      const data = []
      this.businessChannel.forEach((item) => {
        data.push({
          [item]: this.businessRemark[item] || ''
        })
      })
      return data
    },
    change () {
      let value = this.getValue()
      this.$emit('input', value)
    },
    isChecked (value) {
      return this.businessChannel.includes(value)
    },

    validate (cb) {
      let value = this.getValue()
      let pass = true
      this.showErr = {}
      if (!value) pass = false
      else {
        for (let i = 0; i < value.length; i++) {
          const item = value[i]
          for (let key in item) {
            let tempPass = true
            if (this.$refs[key] && this.$refs[key][0] && !item[key]) {
              tempPass = false
              pass && (pass = false)
            }
            this.showErr[key] = !tempPass
          }
          // if (!pass) break
        }
      }
      cb && pass && cb(pass)
      return pass
    }
  }
}
</script>

<style lang="scss" scoped>
.error-msg {
  margin-top: 3px;
  font-size: 24px;
  color: #e64340;
}
.check-required {
  color: #e64340;
  position: relative;
  top: 54Px;
  z-index: 1;
}
</style>
